// extracted by mini-css-extract-plugin
module.exports = {"tpLogoMenu":"home_tpLogoMenu__3NnV4","loginButtons":"home_loginButtons__1GAPI"};